module.exports = __webpack_public_path__ + "img/amex.5e22690f.svg";